define('DisplayShippingType', [
    'DisplayShippingType.View',
    'ProductDetails.Full.View',
    'ProductDetails.QuickView.View'
], function AdvisorTags(
    DisplayShippingTypeView,
    ProductDetailsFullView,
    ProductDetailsQuickViewView
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            ProductDetailsFullView.addChildViews({
                'ShippingType': function displayShippingType() {
                    return new DisplayShippingTypeView({
                        model: this.model
                    });
                }
            });
            ProductDetailsQuickViewView.addChildViews({
                'ShippingType': function displayShippingType() {
                    return new DisplayShippingTypeView({
                        model: this.model
                    });
                }
            });
        }
    };
});

